/* eslint-disable @typescript-eslint/naming-convention */
export enum PaymentStatusOptionIdsEnum {
    'NONE' = 0,
    'Bargeld' = 1,
    'Payback' = 3,
}
